import { render, staticRenderFns } from "./Footergrid.vue?vue&type=template&id=4abfd4f6&scoped=true&"
import script from "./Footergrid.vue?vue&type=script&lang=js&"
export * from "./Footergrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abfd4f6",
  null
  
)

export default component.exports